export const PAGES = {
    USERS: {
        title: 'Users',
        heading: 'Users',
        route: '/users'
    },
    VIEW_CONFIGURATION: {
        title: 'View Configuration',
        heading: 'View & Manage Configurations',
        route: '/configurations'
    },
    CREATE_CONFIGURATION: {
        title: 'Create Configuration',
        heading: 'Create Configuration',
        route: '/create-configuration'
    },
    DEVICES: {
        title: 'Devices',
        heading: 'Devices',
        route: '/devices'
    },
    PLATFORM_AUDIT_LOGS: {
        title: 'Platform Audit Logs',
        heading: 'Platform Audit Logs',
        route: '/audit-logs'
    },
    DEVICE_EXPORT: {
        title: 'Device Export',
        heading: 'Device Export',
        route: '/platform/devices'
    },
    PARTNERS: {
        title: 'Partners',
        heading: 'Partners',
        route: '/partners'
    },
    BULK_UPLOAD_DEVICES: {
        title: 'Bulk Upload Devices',
        heading: 'Bulk Upload Devices',
        route: '/bulk-upload/devices'
    },
    SOLOPROTECT_USERS: {
        title: 'SoloProtect Users',
        heading: 'SoloProtect Users',
        route: '/internal/users'
    },
    BULK_UPLOAD_SIMS: {
        title: 'Bulk Upload SIMs',
        heading: 'Bulk Upload SIMs',
        route: '/bulk-upload/sims'
    },
    DASHBOARD: {
        title: 'Dashboard',
        heading: 'Dashboard',
        route: '/dashboard'
    },
    CUSTOM_FIELDS: {
        title: 'Custom Fields',
        heading: 'Custom Fields',
        route: '/custom-fields'
    },
    SIM_PROVIDERS: {
        title: 'SIM Providers',
        heading: 'SIM Providers',
        route: '/sim-providers'
    },
    ERRORS: {
        NOT_FOUND: {
            name: 'NOT_FOUND',
            title: 'Not Found',
            route: '/not-found'
        }
    }
} as const;